var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValuehelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M14.5 10.4c-.5.9-.8 2-.8 3.2V22c0 3.6 3 6.6 6.6 6.6h8.5c3.6 0 6.5-3 6.5-6.6v-8.4c0-3.6-3-6.6-6.6-6.6h-8.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M26.9 33.6c-1.2 1.2-2.8 1.9-4.7 1.9h-8.4c-3.7 0-6.6-3-6.6-6.6v-8.4c0-1.4.4-2.6 1.1-3.7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 24.1,
    cy: 17.9,
    r: 2.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValuehelp);
export default __webpack_public_path__ + "static/media/valuehelp.bb5c7373cc827e322047e82ed4ef199b.svg";
export { ForwardRef as ReactComponent };